import {api} from '../../utils/api'


export default {

    /**
     * Get messages list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getList: state => (type, id) => {
        // Return tasks list
        return Object.values(state.messages).filter((m) => m.discussable_id == id /*&& m.discussable_type == type*/ );
    },

    /**
     * Get last message time
     * @param state
     * @returns {default.campaigns|{}}
     */
    getLastMessageTime: state => (id) => {

        // Zero max time
        let maxTime = 0;

        // Find max messasge time
        Object.values(state.messages).filter((m) => m.discussable_id == id).map((m) => {

            // Get unix time
            let ut = api.msTime2Unix(m.time);

            // Store unix time
            if(maxTime < ut) maxTime = ut;
        });

        // Return tasks list
        return maxTime;
    }
}
